import { CopyUser, GenerateUserGroup, User, UserDetailsDto, UserProfile } from "@/services/users/types";
import api from "@/services/api";
import { UserAutoSettings } from "@/store/authentication/types";
import { LegacyUpdateDtoIn, LegacyCreateUserDtoIn } from "../security/types";

export async function getUsers(): Promise<User[]> {
    return new Promise((resolve, reject) => {
        api.get("/user").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getEditorUsers(): Promise<User[]> {
    return new Promise((resolve, reject) => {
        getUsers().then(
            response => {
                resolve(response.filter(x => x.roles.some(y => y.toLowerCase() === "editor")));
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUser(id: string): Promise<UserDetailsDto> {
    return new Promise((resolve, reject) => {
        api.get(`/user/details/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAvailableRoles(id: string): Promise<Array<string>> {
    return new Promise((resolve, reject) => {
        api.get(`/user/availableroles/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAllRoles(): Promise<Array<string>> {
    return new Promise((resolve, reject) => {
        api.get(`/user/roles/`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createUser(user: UserDetailsDto): Promise<string> {
    return new Promise((resolve, reject) => {
        api.post("/user", user).then(
            response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function updateUser(user: UserDetailsDto): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put(`/user/${user.id}`, user).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateLegacyUser(user: LegacyUpdateDtoIn): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put(`/user/legacyUpdate`, user).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createUserFromLegacy(user: LegacyCreateUserDtoIn): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post(`/user/legacyCreate`, user).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteUser(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.delete(`/user/${id}`).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUserProfile(id: string): Promise<UserProfile> {
    return new Promise((resolve, reject) => {
        api.get(`/user/profile/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateUserProfile(user: UserProfile): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/user/profile/", user).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateUserAutoSettings(userAutoSettings: UserAutoSettings): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put("/user/autoSettings/", userAutoSettings).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function copyUser(user: CopyUser): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/user/copy", user).then(
            response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function checkIfUserExists(email: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        api.post(`/user/${email}/exists`, null).then(
            response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function createUserGroupFromUserACL(user: GenerateUserGroup): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/usergroup/createUserGroupFromUserACL", user).then(
            response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function exportUserList(filteredColumnTitles: string[]): Promise<any> {
    return new Promise((resolve, reject) => {
        api.postDownloadFile("/user/exportUserList/", filteredColumnTitles).then(
            response => {
                const blob = new Blob([response.data], { type: "content-type" });
                const url = window.URL.createObjectURL(blob);
                const downloadElement = document.createElement("a");
                downloadElement.href = url;
                downloadElement.download = response.headers.filename;
                downloadElement.click();
                window.URL.revokeObjectURL(url);
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
